import { Injectable } from "@angular/core";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import { BaseJWTService } from "@apps/patient-core/src/app/services/abstracts/jwt.service";
import { isOnUnsupportedPage } from "@apps/patient-core/src/app/utils/unsupported";

dayjs.extend(advancedFormat);

@Injectable({
  providedIn: "root",
})
export class PatientJWTService extends BaseJWTService {
  public get isRestricted(): boolean {
    const { restricted_mode } = this._getParsedJWT() || {};

    // This can be a string or a boolean depending on whether the JWT was create for a short code or the patient has logged in
    // AWS converts all data to strings when it's passed from the JWT authorizer to the lambda function
    return restricted_mode === true || restricted_mode === "true";
  }

  public handleInvalidToken(reload = true): null {
    this.onInvalidJWT.next();

    if (this._locationService.isRootDomain) {
      this._cacheService.clearSession();
      this._cacheService.clear();
    } else {
      this.delete();
    }

    if (reload && !isOnUnsupportedPage()) this._windowService.open("/");
    return null;
  }

  public setToken(jwt: string) {
    super.setToken(jwt);
  }
}
